// extracted by mini-css-extract-plugin
export var measureBox = "_dm-0";